export default "__VITE_ASSET__cc294f83__"